import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextInput, Button, Loading } from '../../components/components';
import { useLanguage } from '../../context/LanguageContext';

import styles from './login.module.css';
import { login, IMAGE_ROOT_URL, userData } from '../../services/api';
import ReactGA from 'react-ga4';
import { useHotel } from '../../context/HotelContext';

const EMAIL_REGEXP = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

const countryList = [
    {
        name: 'Canada',
        dial_code: '+1',
        code: 'CA',
        emoji: '🇨🇦',
        code_value: '1',
    },
    {
        name: 'United States',
        dial_code: '+1',
        code: 'US',
        emoji: '🇺🇸',
        code_value: '1',
    },
    {
        name: 'Russia',
        dial_code: '+7',
        code: 'RU',
        emoji: '🇷🇺',
        code_value: '7',
    },
    {
        name: 'Egypt',
        dial_code: '+20',
        code: 'EG',
        emoji: '🇪🇬',
        code_value: '20',
    },
    {
        name: 'South Africa',
        dial_code: '+27',
        code: 'ZA',
        emoji: '🇿🇦',
        code_value: '27',
    },
    {
        name: 'Greece',
        dial_code: '+30',
        code: 'GR',
        emoji: '🇬🇷',
        code_value: '30',
    },
    {
        name: 'Netherlands',
        dial_code: '+31',
        code: 'NL',
        emoji: '🇳🇱',
        code_value: '31',
    },
    {
        name: 'Belgium',
        dial_code: '+32',
        code: 'BE',
        emoji: '🇧🇪',
        code_value: '32',
    },
    {
        name: 'France',
        dial_code: '+33',
        code: 'FR',
        emoji: '🇫🇷',
        code_value: '33',
    },
    {
        name: 'Spain',
        dial_code: '+34',
        code: 'ES',
        emoji: '🇪🇸',
        code_value: '34',
    },
    {
        name: 'Hungary',
        dial_code: '+36',
        code: 'HU',
        emoji: '🇭🇺',
        code_value: '36',
    },
    {
        name: 'Italy',
        dial_code: '+39',
        code: 'IT',
        emoji: '🇮🇹',
        code_value: '39',
    },
    {
        name: 'Romania',
        dial_code: '+40',
        code: 'RO',
        emoji: '🇷🇴',
        code_value: '40',
    },
    {
        name: 'Switzerland',
        dial_code: '+41',
        code: 'CH',
        emoji: '🇨🇭',
        code_value: '41',
    },
    {
        name: 'Austria',
        dial_code: '+43',
        code: 'AT',
        emoji: '🇦🇹',
        code_value: '43',
    },
    {
        name: 'Guernsey',
        dial_code: '+44',
        code: 'GG',
        emoji: '🇬🇬',
        code_value: '44',
    },
    {
        name: 'Isle of Man',
        dial_code: '+44',
        code: 'IM',
        emoji: '🇮🇲',
        code_value: '44',
    },
    {
        name: 'Jersey',
        dial_code: '+44',
        code: 'JE',
        emoji: '🇯🇪',
        code_value: '44',
    },
    {
        name: 'United Kingdom',
        dial_code: '+44',
        code: 'UK',
        emoji: '🇬🇧',
        code_value: '44',
    },
    {
        name: 'Denmark',
        dial_code: '+45',
        code: 'DK',
        emoji: '🇩🇰',
        code_value: '45',
    },
    {
        name: 'Sweden',
        dial_code: '+46',
        code: 'SE',
        emoji: '🇸🇪',
        code_value: '46',
    },
    {
        name: 'Norway',
        dial_code: '+47',
        code: 'NO',
        emoji: '🇳🇴',
        code_value: '47',
    },
    {
        name: 'Svalbard and Jan Mayen',
        dial_code: '+47',
        code: 'SJ',
        emoji: '🇳🇴',
        code_value: '47',
    },
    {
        name: 'Poland',
        dial_code: '+48',
        code: 'PL',
        emoji: '🇵🇱',
        code_value: '48',
    },
    {
        name: 'Germany',
        dial_code: '+49',
        code: 'DE',
        emoji: '🇩🇪',
        code_value: '49',
    },
    {
        name: 'Peru',
        dial_code: '+51',
        code: 'PE',
        emoji: '🇵🇪',
        code_value: '51',
    },
    {
        name: 'Mexico',
        dial_code: '+52',
        code: 'MX',
        emoji: '🇲🇽',
        code_value: '52',
    },
    {
        name: 'Cuba',
        dial_code: '+53',
        code: 'CU',
        emoji: '🇨🇺',
        code_value: '53',
    },
    {
        name: 'Argentina',
        dial_code: '+54',
        code: 'AR',
        emoji: '🇦🇷',
        code_value: '54',
    },
    {
        name: 'Brazil',
        dial_code: '+55',
        code: 'BR',
        emoji: '🇧🇷',
        code_value: '55',
    },
    {
        name: 'Chile',
        dial_code: '+56',
        code: 'CL',
        emoji: '🇨🇱',
        code_value: '56',
    },
    {
        name: 'Colombia',
        dial_code: '+57',
        code: 'CO',
        emoji: '🇨🇴',
        code_value: '57',
    },
    {
        name: 'Venezuela, Bolivarian Republic of Venezuela',
        dial_code: '+58',
        code: 'VE',
        emoji: '🇻🇪',
        code_value: '58',
    },
    {
        name: 'Malaysia',
        dial_code: '+60',
        code: 'MY',
        emoji: '🇲🇾',
        code_value: '60',
    },
    {
        name: 'Australia',
        dial_code: '+61',
        code: 'AU',
        emoji: '🇦🇺',
        code_value: '61',
    },
    {
        name: 'Christmas Island',
        dial_code: '+61',
        code: 'CX',
        emoji: '🇨🇽',
        code_value: '61',
    },
    {
        name: 'Cocos (Keeling) Islands',
        dial_code: '+61',
        code: 'CC',
        emoji: '🇨🇨',
        code_value: '61',
    },
    {
        name: 'Indonesia',
        dial_code: '+62',
        code: 'ID',
        emoji: '🇮🇩',
        code_value: '62',
    },
    {
        name: 'Philippines',
        dial_code: '+63',
        code: 'PH',
        emoji: '🇵🇭',
        code_value: '63',
    },
    {
        name: 'New Zealand',
        dial_code: '+64',
        code: 'NZ',
        emoji: '🇳🇿',
        code_value: '64',
    },
    {
        name: 'Singapore',
        dial_code: '+65',
        code: 'SG',
        emoji: '🇸🇬',
        code_value: '65',
    },
    {
        name: 'Thailand',
        dial_code: '+66',
        code: 'TH',
        emoji: '🇹🇭',
        code_value: '66',
    },
    {
        name: 'Kazakhstan',
        dial_code: '+77',
        code: 'KZ',
        emoji: '🇰🇿',
        code_value: '77',
    },
    {
        name: 'Japan',
        dial_code: '+81',
        code: 'JP',
        emoji: '🗾',
        code_value: '81',
    },
    {
        name: 'Korea, Republic of South Korea',
        dial_code: '+82',
        code: 'KR',
        emoji: '🇰🇷',
        code_value: '82',
    },
    {
        name: 'Vietnam',
        dial_code: '+84',
        code: 'VN',
        emoji: '🇻🇳',
        code_value: '84',
    },
    {
        name: 'China',
        dial_code: '+86',
        code: 'CN',
        emoji: '🇨🇳',
        code_value: '86',
    },
    {
        name: 'Turkey',
        dial_code: '+90',
        code: 'TR',
        emoji: '🇹🇷',
        code_value: '90',
    },
    {
        name: 'India',
        dial_code: '+91',
        code: 'IN',
        emoji: '🇮🇳',
        code_value: '91',
    },
    {
        name: 'Pakistan',
        dial_code: '+92',
        code: 'PK',
        emoji: '🇵🇰',
        code_value: '92',
    },
    {
        name: 'Afghanistan',
        dial_code: '+93',
        code: 'AF',
        emoji: '🇦🇫',
        code_value: '93',
    },
    {
        name: 'Sri Lanka',
        dial_code: '+94',
        code: 'LK',
        emoji: '🇱🇰',
        code_value: '94',
    },
    {
        name: 'Myanmar',
        dial_code: '+95',
        code: 'MM',
        emoji: '🇲🇲',
        code_value: '95',
    },
    {
        name: 'Iran, Islamic Republic of Persian Gulf',
        dial_code: '+98',
        code: 'IR',
        emoji: '🇮🇷',
        code_value: '98',
    },
    {
        name: 'South Sudan',
        dial_code: '+211',
        code: 'SS',
        emoji: '🇸🇸',
        code_value: '211',
    },
    {
        name: 'Morocco',
        dial_code: '+212',
        code: 'MA',
        emoji: '🇲🇦',
        code_value: '212',
    },
    {
        name: 'Algeria',
        dial_code: '+213',
        code: 'DZ',
        emoji: '🇩🇿',
        code_value: '213',
    },
    {
        name: 'Tunisia',
        dial_code: '+216',
        code: 'TN',
        emoji: '🇹🇳',
        code_value: '216',
    },
    {
        name: 'Libyan Arab Jamahiriya',
        dial_code: '+218',
        code: 'LY',
        emoji: '🇱🇾',
        code_value: '218',
    },
    {
        name: 'Gambia',
        dial_code: '+220',
        code: 'GM',
        emoji: '🇬🇲',
        code_value: '220',
    },
    {
        name: 'Senegal',
        dial_code: '+221',
        code: 'SN',
        emoji: '🇸🇳',
        code_value: '221',
    },
    {
        name: 'Mauritania',
        dial_code: '+222',
        code: 'MR',
        emoji: '🇲🇷',
        code_value: '222',
    },
    {
        name: 'Mali',
        dial_code: '+223',
        code: 'ML',
        emoji: '🇲🇱',
        code_value: '223',
    },
    {
        name: 'Guinea',
        dial_code: '+224',
        code: 'GN',
        emoji: '🇬🇳',
        code_value: '224',
    },
    {
        name: "Cote d'Ivoire",
        dial_code: '+225',
        code: 'CI',
        emoji: '🇨🇮',
        code_value: '225',
    },
    {
        name: 'Burkina Faso',
        dial_code: '+226',
        code: 'BF',
        emoji: '🇧🇫',
        code_value: '226',
    },
    {
        name: 'Niger',
        dial_code: '+227',
        code: 'NE',
        emoji: '🇳🇪',
        code_value: '227',
    },
    {
        name: 'Togo',
        dial_code: '+228',
        code: 'TG',
        emoji: '🇹🇬',
        code_value: '228',
    },
    {
        name: 'Benin',
        dial_code: '+229',
        code: 'BJ',
        emoji: '🇧🇯',
        code_value: '229',
    },
    {
        name: 'Mauritius',
        dial_code: '+230',
        code: 'MU',
        emoji: '🇲🇺',
        code_value: '230',
    },
    {
        name: 'Liberia',
        dial_code: '+231',
        code: 'LR',
        emoji: '🇱🇷',
        code_value: '231',
    },
    {
        name: 'Sierra Leone',
        dial_code: '+232',
        code: 'SL',
        emoji: '🇸🇱',
        code_value: '232',
    },
    {
        name: 'Ghana',
        dial_code: '+233',
        code: 'GH',
        emoji: '🇬🇭',
        code_value: '233',
    },
    {
        name: 'Nigeria',
        dial_code: '+234',
        code: 'NG',
        emoji: '🇳🇬',
        code_value: '234',
    },
    {
        name: 'Chad',
        dial_code: '+235',
        code: 'TD',
        emoji: '🇹🇩',
        code_value: '235',
    },
    {
        name: 'Central African Republic',
        dial_code: '+236',
        code: 'CF',
        emoji: '🇨🇫',
        code_value: '236',
    },
    {
        name: 'Cameroon',
        dial_code: '+237',
        code: 'CM',
        emoji: '🇨🇲',
        code_value: '237',
    },
    {
        name: 'Cape Verde',
        dial_code: '+238',
        code: 'CV',
        emoji: '🇨🇻',
        code_value: '238',
    },
    {
        name: 'Sao Tome and Principe',
        dial_code: '+239',
        code: 'ST',
        emoji: '🇸🇹',
        code_value: '239',
    },
    {
        name: 'Equatorial Guinea',
        dial_code: '+240',
        code: 'GQ',
        emoji: '🇬🇶',
        code_value: '240',
    },
    {
        name: 'Gabon',
        dial_code: '+241',
        code: 'GA',
        emoji: '🇬🇦',
        code_value: '241',
    },
    {
        name: 'Congo',
        dial_code: '+242',
        code: 'CG',
        emoji: '🇨🇬',
        code_value: '242',
    },
    {
        name: 'Congo, The Democratic Republic of the Congo',
        dial_code: '+243',
        code: 'CD',
        emoji: '🇨🇩',
        code_value: '243',
    },
    {
        name: 'Angola',
        dial_code: '+244',
        code: 'AO',
        emoji: '🇦🇴',
        code_value: '244',
    },
    {
        name: 'Guinea-Bissau',
        dial_code: '+245',
        code: 'GW',
        emoji: '🇬🇼',
        code_value: '245',
    },
    {
        name: 'British Indian Ocean Territory',
        dial_code: '+246',
        code: 'IO',
        emoji: '🇮🇴',
        code_value: '246',
    },
    {
        name: 'Seychelles',
        dial_code: '+248',
        code: 'SC',
        emoji: '🇸🇨',
        code_value: '248',
    },
    {
        name: 'Sudan',
        dial_code: '+249',
        code: 'SD',
        emoji: '🇸🇩',
        code_value: '249',
    },
    {
        name: 'Rwanda',
        dial_code: '+250',
        code: 'RW',
        emoji: '🇷🇼',
        code_value: '250',
    },
    {
        name: 'Ethiopia',
        dial_code: '+251',
        code: 'ET',
        emoji: '🇪🇹',
        code_value: '251',
    },
    {
        name: 'Somalia',
        dial_code: '+252',
        code: 'SO',
        emoji: '🇸🇴',
        code_value: '252',
    },
    {
        name: 'Djibouti',
        dial_code: '+253',
        code: 'DJ',
        emoji: '🇩🇯',
        code_value: '253',
    },
    {
        name: 'Kenya',
        dial_code: '+254',
        code: 'KE',
        emoji: '🇰🇪',
        code_value: '254',
    },
    {
        name: 'Tanzania, United Republic of Tanzania',
        dial_code: '+255',
        code: 'TZ',
        emoji: '🇹🇿',
        code_value: '255',
    },
    {
        name: 'Uganda',
        dial_code: '+256',
        code: 'UG',
        emoji: '🇺🇬',
        code_value: '256',
    },
    {
        name: 'Burundi',
        dial_code: '+257',
        code: 'BI',
        emoji: '🇧🇮',
        code_value: '257',
    },
    {
        name: 'Mozambique',
        dial_code: '+258',
        code: 'MZ',
        emoji: '🇲🇿',
        code_value: '258',
    },
    {
        name: 'Zambia',
        dial_code: '+260',
        code: 'ZM',
        emoji: '🇿🇲',
        code_value: '260',
    },
    {
        name: 'Madagascar',
        dial_code: '+261',
        code: 'MG',
        emoji: '🇲🇬',
        code_value: '261',
    },
    {
        name: 'Mayotte',
        dial_code: '+262',
        code: 'YT',
        emoji: '🇾🇹',
        code_value: '262',
    },
    {
        name: 'Reunion',
        dial_code: '+262',
        code: 'RE',
        emoji: '🇷🇪',
        code_value: '262',
    },
    {
        name: 'Zimbabwe',
        dial_code: '+263',
        code: 'ZW',
        emoji: '🇿🇼',
        code_value: '263',
    },
    {
        name: 'Namibia',
        dial_code: '+264',
        code: 'NA',
        emoji: '🇳🇦',
        code_value: '264',
    },
    {
        name: 'Malawi',
        dial_code: '+265',
        code: 'MW',
        emoji: '🇲🇼',
        code_value: '265',
    },
    {
        name: 'Lesotho',
        dial_code: '+266',
        code: 'LS',
        emoji: '🇱🇸',
        code_value: '266',
    },
    {
        name: 'Botswana',
        dial_code: '+267',
        code: 'BW',
        emoji: '🇧🇼',
        code_value: '267',
    },
    {
        name: 'Swaziland',
        dial_code: '+268',
        code: 'SZ',
        emoji: '🇸🇿',
        code_value: '268',
    },
    {
        name: 'Comoros',
        dial_code: '+269',
        code: 'KM',
        emoji: '🇰🇲',
        code_value: '269',
    },
    {
        name: 'Saint Helena, Ascension and Tristan Da Cunha',
        dial_code: '+290',
        code: 'SH',
        emoji: '🇸🇭',
        code_value: '290',
    },
    {
        name: 'Eritrea',
        dial_code: '+291',
        code: 'ER',
        emoji: '🇪🇷',
        code_value: '291',
    },
    {
        name: 'Aruba',
        dial_code: '+297',
        code: 'AW',
        emoji: '🇦🇼',
        code_value: '297',
    },
    {
        name: 'Faroe Islands',
        dial_code: '+298',
        code: 'FO',
        emoji: '🇫🇴',
        code_value: '298',
    },
    {
        name: 'Greenland',
        dial_code: '+299',
        code: 'GL',
        emoji: '🇬🇱',
        code_value: '299',
    },
    {
        name: 'Cayman Islands',
        dial_code: '+ 345',
        code: 'KY',
        emoji: '🇰🇾',
        code_value: ' 345',
    },
    {
        name: 'Gibraltar',
        dial_code: '+350',
        code: 'GI',
        emoji: '🇬🇮',
        code_value: '350',
    },
    {
        name: 'Portugal',
        dial_code: '+351',
        code: 'PT',
        emoji: '🇵🇹',
        code_value: '351',
    },
    {
        name: 'Luxembourg',
        dial_code: '+352',
        code: 'LU',
        emoji: '🇱🇺',
        code_value: '352',
    },
    {
        name: 'Ireland',
        dial_code: '+353',
        code: 'IE',
        emoji: '🇮🇪',
        code_value: '353',
    },
    {
        name: 'Iceland',
        dial_code: '+354',
        code: 'IS',
        emoji: '🇮🇸',
        code_value: '354',
    },
    {
        name: 'Albania',
        dial_code: '+355',
        code: 'AL',
        emoji: '🇦🇱',
        code_value: '355',
    },
    {
        name: 'Malta',
        dial_code: '+356',
        code: 'MT',
        emoji: '🇲🇹',
        code_value: '356',
    },
    {
        name: 'Cyprus',
        dial_code: '+357',
        code: 'CY',
        emoji: '🇨🇾',
        code_value: '357',
    },
    {
        name: 'Aland Islands',
        dial_code: '+358',
        code: 'AX',
        emoji: '🇦🇽',
        code_value: '358',
    },
    {
        name: 'Finland',
        dial_code: '+358',
        code: 'FI',
        emoji: '🇫🇮',
        code_value: '358',
    },
    {
        name: 'Bulgaria',
        dial_code: '+359',
        code: 'BG',
        emoji: '🇧🇬',
        code_value: '359',
    },
    {
        name: 'Lithuania',
        dial_code: '+370',
        code: 'LT',
        emoji: '🇱🇹',
        code_value: '370',
    },
    {
        name: 'Latvia',
        dial_code: '+371',
        code: 'LV',
        emoji: '🇱🇻',
        code_value: '371',
    },
    {
        name: 'Estonia',
        dial_code: '+372',
        code: 'EE',
        emoji: '🇪🇪',
        code_value: '372',
    },
    {
        name: 'Moldova',
        dial_code: '+373',
        code: 'MD',
        emoji: '🇲🇩',
        code_value: '373',
    },
    {
        name: 'Armenia',
        dial_code: '+374',
        code: 'AM',
        emoji: '🇦🇲',
        code_value: '374',
    },
    {
        name: 'Belarus',
        dial_code: '+375',
        code: 'BY',
        emoji: '🇧🇾',
        code_value: '375',
    },
    {
        name: 'Andorra',
        dial_code: '+376',
        code: 'AD',
        emoji: '🇦🇩',
        code_value: '376',
    },
    {
        name: 'Monaco',
        dial_code: '+377',
        code: 'MC',
        emoji: '🇲🇨',
        code_value: '377',
    },
    {
        name: 'San Marino',
        dial_code: '+378',
        code: 'SM',
        emoji: '🇸🇲',
        code_value: '378',
    },
    {
        name: 'Holy See (Vatican City State)',
        dial_code: '+379',
        code: 'VA',
        emoji: '🇻🇦',
        code_value: '379',
    },
    {
        name: 'Ukraine',
        dial_code: '+380',
        code: 'UA',
        emoji: '🇺🇦',
        code_value: '380',
    },
    {
        name: 'Serbia',
        dial_code: '+381',
        code: 'RS',
        emoji: '🇷🇸',
        code_value: '381',
    },
    {
        name: 'Montenegro',
        dial_code: '+382',
        code: 'ME',
        emoji: '🇲🇪',
        code_value: '382',
    },
    {
        name: 'Croatia',
        dial_code: '+385',
        code: 'HR',
        emoji: '🇭🇷',
        code_value: '385',
    },
    {
        name: 'Slovenia',
        dial_code: '+386',
        code: 'SI',
        emoji: '🇸🇮',
        code_value: '386',
    },
    {
        name: 'Bosnia and Herzegovina',
        dial_code: '+387',
        code: 'BA',
        emoji: '🇧🇦',
        code_value: '387',
    },
    {
        name: 'Macedonia',
        dial_code: '+389',
        code: 'MK',
        emoji: '🇲🇰',
        code_value: '389',
    },
    {
        name: 'Czech Republic',
        dial_code: '+420',
        code: 'CZ',
        emoji: '🇨🇿',
        code_value: '420',
    },
    {
        name: 'Slovakia',
        dial_code: '+421',
        code: 'SK',
        emoji: '🇸🇰',
        code_value: '421',
    },
    {
        name: 'Liechtenstein',
        dial_code: '+423',
        code: 'LI',
        emoji: '🇱🇮',
        code_value: '423',
    },
    {
        name: 'Falkland Islands (Malvinas)',
        dial_code: '+500',
        code: 'FK',
        emoji: '🇫🇰',
        code_value: '500',
    },
    {
        name: 'South Georgia and the South Sandwich Islands',
        dial_code: '+500',
        code: 'GS',
        emoji: '🇬🇸',
        code_value: '500',
    },
    {
        name: 'Belize',
        dial_code: '+501',
        code: 'BZ',
        emoji: '🇧🇿',
        code_value: '501',
    },
    {
        name: 'Guatemala',
        dial_code: '+502',
        code: 'GT',
        emoji: '🇬🇹',
        code_value: '502',
    },
    {
        name: 'El Salvador',
        dial_code: '+503',
        code: 'SV',
        emoji: '🇸🇻',
        code_value: '503',
    },
    {
        name: 'Honduras',
        dial_code: '+504',
        code: 'HN',
        emoji: '🇭🇳',
        code_value: '504',
    },
    {
        name: 'Nicaragua',
        dial_code: '+505',
        code: 'NI',
        emoji: '🇳🇮',
        code_value: '505',
    },
    {
        name: 'Costa Rica',
        dial_code: '+506',
        code: 'CR',
        emoji: '🇨🇷',
        code_value: '506',
    },
    {
        name: 'Panama',
        dial_code: '+507',
        code: 'PA',
        emoji: '🇵🇦',
        code_value: '507',
    },
    {
        name: 'Saint Pierre and Miquelon',
        dial_code: '+508',
        code: 'PM',
        emoji: '🇵🇲',
        code_value: '508',
    },
    {
        name: 'Haiti',
        dial_code: '+509',
        code: 'HT',
        emoji: '🇭🇹',
        code_value: '509',
    },
    {
        name: 'Guadeloupe',
        dial_code: '+590',
        code: 'GP',
        emoji: '🇬🇵',
        code_value: '590',
    },
    {
        name: 'Saint Barthelemy',
        dial_code: '+590',
        code: 'BL',
        emoji: '🇧🇱',
        code_value: '590',
    },
    {
        name: 'Saint Martin',
        dial_code: '+590',
        code: 'MF',
        emoji: '🇫🇷',
        code_value: '590',
    },
    {
        name: 'Bolivia, Plurinational State of',
        dial_code: '+591',
        code: 'BO',
        emoji: '🇧🇴',
        code_value: '591',
    },
    {
        name: 'Ecuador',
        dial_code: '+593',
        code: 'EC',
        emoji: '🇪🇨',
        code_value: '593',
    },
    {
        name: 'French Guiana',
        dial_code: '+594',
        code: 'GF',
        emoji: '🇬🇫',
        code_value: '594',
    },
    {
        name: 'Guyana',
        dial_code: '+595',
        code: 'GY',
        emoji: '🇬🇾',
        code_value: '595',
    },
    {
        name: 'Paraguay',
        dial_code: '+595',
        code: 'PY',
        emoji: '🇵🇾',
        code_value: '595',
    },
    {
        name: 'Martinique',
        dial_code: '+596',
        code: 'MQ',
        emoji: '🇲🇶',
        code_value: '596',
    },
    {
        name: 'Suriname',
        dial_code: '+597',
        code: 'SR',
        emoji: '🇸🇷',
        code_value: '597',
    },
    {
        name: 'Uruguay',
        dial_code: '+598',
        code: 'UY',
        emoji: '🇺🇾',
        code_value: '598',
    },
    {
        name: 'Netherlands Antilles',
        dial_code: '+599',
        code: 'AN',
        emoji: '🇳🇱',
        code_value: '599',
    },
    {
        name: 'Timor-Leste',
        dial_code: '+670',
        code: 'TL',
        emoji: '🇹🇱',
        code_value: '670',
    },
    {
        name: 'Antarctica',
        dial_code: '+672',
        code: 'AQ',
        emoji: '🇦🇶',
        code_value: '672',
    },
    {
        name: 'Norfolk Island',
        dial_code: '+672',
        code: 'NF',
        emoji: '🇳🇫',
        code_value: '672',
    },
    {
        name: 'Brunei Darussalam',
        dial_code: '+673',
        code: 'BN',
        emoji: '🇧🇳',
        code_value: '673',
    },
    {
        name: 'Nauru',
        dial_code: '+674',
        code: 'NR',
        emoji: '🇳🇷',
        code_value: '674',
    },
    {
        name: 'Papua New Guinea',
        dial_code: '+675',
        code: 'PG',
        emoji: '🇵🇬',
        code_value: '675',
    },
    {
        name: 'Tonga',
        dial_code: '+676',
        code: 'TO',
        emoji: '🇹🇴',
        code_value: '676',
    },
    {
        name: 'Solomon Islands',
        dial_code: '+677',
        code: 'SB',
        emoji: '🇸🇧',
        code_value: '677',
    },
    {
        name: 'Vanuatu',
        dial_code: '+678',
        code: 'VU',
        emoji: '🇻🇺',
        code_value: '678',
    },
    {
        name: 'Fiji',
        dial_code: '+679',
        code: 'FJ',
        emoji: '🇫🇯',
        code_value: '679',
    },
    {
        name: 'Palau',
        dial_code: '+680',
        code: 'PW',
        emoji: '🇵🇼',
        code_value: '680',
    },
    {
        name: 'Wallis and Futuna',
        dial_code: '+681',
        code: 'WF',
        emoji: '🇼🇫',
        code_value: '681',
    },
    {
        name: 'Cook Islands',
        dial_code: '+682',
        code: 'CK',
        emoji: '🇨🇰',
        code_value: '682',
    },
    {
        name: 'Niue',
        dial_code: '+683',
        code: 'NU',
        emoji: '🇳🇺',
        code_value: '683',
    },
    {
        name: 'Samoa',
        dial_code: '+685',
        code: 'WS',
        emoji: '🇼🇸',
        code_value: '685',
    },
    {
        name: 'Kiribati',
        dial_code: '+686',
        code: 'KI',
        emoji: '🇰🇮',
        code_value: '686',
    },
    {
        name: 'New Caledonia',
        dial_code: '+687',
        code: 'NC',
        emoji: '🇳🇨',
        code_value: '687',
    },
    {
        name: 'Tuvalu',
        dial_code: '+688',
        code: 'TV',
        emoji: '🇹🇻',
        code_value: '688',
    },
    {
        name: 'French Polynesia',
        dial_code: '+689',
        code: 'PF',
        emoji: '🇵🇫',
        code_value: '689',
    },
    {
        name: 'Tokelau',
        dial_code: '+690',
        code: 'TK',
        emoji: '🇹🇰',
        code_value: '690',
    },
    {
        name: 'Micronesia, Federated States of Micronesia',
        dial_code: '+691',
        code: 'FM',
        emoji: '🇫🇲',
        code_value: '691',
    },
    {
        name: 'Marshall Islands',
        dial_code: '+692',
        code: 'MH',
        emoji: '🇲🇭',
        code_value: '692',
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        dial_code: '+850',
        code: 'KP',
        emoji: '🇰🇵',
        code_value: '850',
    },
    {
        name: 'Hong Kong',
        dial_code: '+852',
        code: 'HK',
        emoji: '🇭🇰',
        code_value: '852',
    },
    {
        name: 'Macao',
        dial_code: '+853',
        code: 'MO',
        emoji: '🇲🇴',
        code_value: '853',
    },
    {
        name: 'Cambodia',
        dial_code: '+855',
        code: 'KH',
        emoji: '🇰🇭',
        code_value: '855',
    },
    {
        name: 'Laos',
        dial_code: '+856',
        code: 'LA',
        emoji: '🇱🇦',
        code_value: '856',
    },
    {
        name: 'Pitcairn',
        dial_code: '+872',
        code: 'PN',
        emoji: '🇵🇳',
        code_value: '872',
    },
    {
        name: 'Bangladesh',
        dial_code: '+880',
        code: 'BD',
        emoji: '🇧🇩',
        code_value: '880',
    },
    {
        name: 'Taiwan',
        dial_code: '+886',
        code: 'TW',
        emoji: '🇹🇼',
        code_value: '886',
    },
    {
        name: 'Maldives',
        dial_code: '+960',
        code: 'MV',
        emoji: '🇲🇻',
        code_value: '960',
    },
    {
        name: 'Lebanon',
        dial_code: '+961',
        code: 'LB',
        emoji: '🇱🇧',
        code_value: '961',
    },
    {
        name: 'Jordan',
        dial_code: '+962',
        code: 'JO',
        emoji: '🇯🇴',
        code_value: '962',
    },
    {
        name: 'Syrian Arab Republic',
        dial_code: '+963',
        code: 'SY',
        emoji: '🇸🇾',
        code_value: '963',
    },
    {
        name: 'Iraq',
        dial_code: '+964',
        code: 'IQ',
        emoji: '🇮🇶',
        code_value: '964',
    },
    {
        name: 'Kuwait',
        dial_code: '+965',
        code: 'KW',
        emoji: '🇰🇼',
        code_value: '965',
    },
    {
        name: 'Saudi Arabia',
        dial_code: '+966',
        code: 'SA',
        emoji: '🇸🇦',
        code_value: '966',
    },
    {
        name: 'Yemen',
        dial_code: '+967',
        code: 'YE',
        emoji: '🇾🇪',
        code_value: '967',
    },
    {
        name: 'Oman',
        dial_code: '+968',
        code: 'OM',
        emoji: '🇴🇲',
        code_value: '968',
    },
    {
        name: 'Palestinian Territory, Occupied',
        dial_code: '+970',
        code: 'PS',
        emoji: '🇵🇸',
        code_value: '970',
    },
    {
        name: 'United Arab Emirates',
        dial_code: '+971',
        code: 'AE',
        emoji: '🇦🇪',
        code_value: '971',
    },
    {
        name: 'Israel',
        dial_code: '+972',
        code: 'IL',
        emoji: '🇮🇱',
        code_value: '972',
    },
    {
        name: 'Bahrain',
        dial_code: '+973',
        code: 'BH',
        emoji: '🇧🇭',
        code_value: '973',
    },
    {
        name: 'Qatar',
        dial_code: '+974',
        code: 'QA',
        emoji: '🇶🇦',
        code_value: '974',
    },
    {
        name: 'Bhutan',
        dial_code: '+975',
        code: 'BT',
        emoji: '🇧🇹',
        code_value: '975',
    },
    {
        name: 'Mongolia',
        dial_code: '+976',
        code: 'MN',
        emoji: '🇲🇳',
        code_value: '976',
    },
    {
        name: 'Nepal',
        dial_code: '+977',
        code: 'NP',
        emoji: '🇳🇵',
        code_value: '977',
    },
    {
        name: 'Tajikistan',
        dial_code: '+992',
        code: 'TJ',
        emoji: '🇹🇯',
        code_value: '992',
    },
    {
        name: 'Turkmenistan',
        dial_code: '+993',
        code: 'TM',
        emoji: '🇹🇲',
        code_value: '993',
    },
    {
        name: 'Azerbaijan',
        dial_code: '+994',
        code: 'AZ',
        emoji: '🇦🇿',
        code_value: '994',
    },
    {
        name: 'Georgia',
        dial_code: '+995',
        code: 'GE',
        emoji: '🇬🇪',
        code_value: '995',
    },
    {
        name: 'Kyrgyzstan',
        dial_code: '+996',
        code: 'KG',
        emoji: '🇰🇬',
        code_value: '996',
    },
    {
        name: 'Uzbekistan',
        dial_code: '+998',
        code: 'UZ',
        emoji: '🇺🇿',
        code_value: '998',
    },
    {
        name: 'Bahamas',
        dial_code: '+1242',
        code: 'BS',
        emoji: '🇧🇸',
        code_value: '1242',
    },
    {
        name: 'Barbados',
        dial_code: '+1246',
        code: 'BB',
        emoji: '🇧🇧',
        code_value: '1246',
    },
    {
        name: 'Anguilla',
        dial_code: '+1264',
        code: 'AI',
        emoji: '🇦🇮',
        code_value: '1264',
    },
    {
        name: 'Antigua and Barbuda',
        dial_code: '+1268',
        code: 'AG',
        emoji: '🇦🇬',
        code_value: '1268',
    },
    {
        name: 'Virgin Islands, British',
        dial_code: '+1284',
        code: 'VG',
        emoji: '🇻🇬',
        code_value: '1284',
    },
    {
        name: 'Virgin Islands, U.S.',
        dial_code: '+1340',
        code: 'VI',
        emoji: '🇻🇮',
        code_value: '1340',
    },
    {
        name: 'Bermuda',
        dial_code: '+1441',
        code: 'BM',
        emoji: '🇧🇲',
        code_value: '1441',
    },
    {
        name: 'Grenada',
        dial_code: '+1473',
        code: 'GD',
        emoji: '🇬🇩',
        code_value: '1473',
    },
    {
        name: 'Turks and Caicos Islands',
        dial_code: '+1649',
        code: 'TC',
        emoji: '🇹🇨',
        code_value: '1649',
    },
    {
        name: 'Montserrat',
        dial_code: '+1664',
        code: 'MS',
        emoji: '🇲🇸',
        code_value: '1664',
    },
    {
        name: 'Northern Mariana Islands',
        dial_code: '+1670',
        code: 'MP',
        emoji: '🇲🇵',
        code_value: '1670',
    },
    {
        name: 'Guam',
        dial_code: '+1671',
        code: 'GU',
        emoji: '🇬🇺',
        code_value: '1671',
    },
    {
        name: 'American Samoa',
        dial_code: '+1684',
        code: 'AS',
        emoji: '🇦🇸',
        code_value: '1684',
    },
    {
        name: 'Saint Lucia',
        dial_code: '+1758',
        code: 'LC',
        emoji: '🇱🇨',
        code_value: '1758',
    },
    {
        name: 'Dominica',
        dial_code: '+1767',
        code: 'DM',
        emoji: '🇩🇲',
        code_value: '1767',
    },
    {
        name: 'Saint Vincent and the Grenadines',
        dial_code: '+1784',
        code: 'VC',
        emoji: '🇻🇨',
        code_value: '1784',
    },
    {
        name: 'Dominican Republic',
        dial_code: '+1849',
        code: 'DO',
        emoji: '🇩🇴',
        code_value: '1849',
    },
    {
        name: 'Trinidad and Tobago',
        dial_code: '+1868',
        code: 'TT',
        emoji: '🇹🇹',
        code_value: '1868',
    },
    {
        name: 'Saint Kitts and Nevis',
        dial_code: '+1869',
        code: 'KN',
        emoji: '🇰🇳',
        code_value: '1869',
    },
    {
        name: 'Jamaica',
        dial_code: '+1876',
        code: 'JM',
        emoji: '🇯🇲',
        code_value: '1876',
    },
    {
        name: 'Puerto Rico',
        dial_code: '+1939',
        code: 'PR',
        emoji: '🇵🇷',
        code_value: '1939',
    },
];
const Login = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [isEmptyError, setIsEmptyError] = useState('');
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [mobile, setMobile] = useState('');
    const [mobile_country_code, setmobile_country_code] = useState('91');
    const [fullName, setFullName] = useState('');
    const { translations, hotelDetails } = useHotel();
    const hotelId = localStorage.getItem('hotel_id') || false;
    const navigate = useNavigate();
    const location = useLocation();
    const forwardUrl = location.search ? location.search.split('=').pop() : '/';
    console.log(forwardUrl);
    const { t, lang } = useLanguage();

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search,
            language: lang,
        });
    }, []);

    useEffect(() => {
        if (
            hotelDetails?.hotel_config &&
            hotelDetails?.hotel_config?.required_guest_details &&
            hotelDetails?.hotel_config?.required_guest_details.length === 0
        ) {
            setLoading(true);
            handleSubmit();
        }
    }, [hotelDetails]);

    const handleSubmit = async () => {
        // if hotel_config is set, check individual validations for required fields
        if (
            hotelDetails?.hotel_config &&
            hotelDetails?.hotel_config?.required_guest_details &&
            hotelDetails?.hotel_config?.required_guest_details.length !== 0
        ) {
            if (hotelDetails?.hotel_config) {
                if (
                    hotelDetails?.hotel_config?.required_guest_details.includes(
                        'email'
                    )
                ) {
                    if (email === undefined || email === '') {
                        setIsEmptyError('Please enter your details.');
                        return false;
                    }
                }
                if (
                    hotelDetails?.hotel_config?.required_guest_details.includes(
                        'name'
                    )
                ) {
                    if (fullName === undefined || fullName === '') {
                        setIsEmptyError('Please enter your details.');
                        return false;
                    }
                }
                if (
                    hotelDetails?.hotel_config?.required_guest_details.includes(
                        'last_name'
                    )
                ) {
                    if (lastName === undefined || lastName === '') {
                        setIsEmptyError('Please enter your details.');
                        return false;
                    }
                }
                if (
                    hotelDetails?.hotel_config?.required_guest_details.includes(
                        'first_name'
                    )
                ) {
                    if (firstName === undefined || firstName === '') {
                        setIsEmptyError('Please enter your details.');
                        return false;
                    }
                }
                if (
                    hotelDetails?.hotel_config?.required_guest_details.includes(
                        'mobile'
                    )
                ) {
                    if (mobile === undefined || mobile === '') {
                        setIsEmptyError('Please enter your details.');
                        return false;
                    }
                }
            }
        }

        ReactGA.set({ email: email });
        ReactGA.set({ name: fullName });
        ReactGA.set({ firstName: firstName });
        ReactGA.set({ lastname: lastName });
        ReactGA.set({ mobile: mobile });
        ReactGA.set({ mobile_country_code: mobile_country_code });

        setLoading(true);
        let dataObj = {
            hotelId,
        };

        if (
            hotelDetails?.hotel_config &&
            hotelDetails?.hotel_config?.required_guest_details &&
            hotelDetails?.hotel_config?.required_guest_details.length === 0
        ) {
            dataObj['name'] = 'guestUser';
        }
        if (hotelDetails?.hotel_config) {
            if (
                hotelDetails?.hotel_config?.required_guest_details.includes(
                    'email'
                )
            ) {
                dataObj['email'] = email;
            }
            if (
                hotelDetails?.hotel_config?.required_guest_details.includes(
                    'name'
                )
            ) {
                dataObj['name'] = fullName;
            }
            if (
                hotelDetails?.hotel_config?.required_guest_details.includes(
                    'last_name'
                )
            ) {
                dataObj['last_name'] = lastName;
            }
            if (
                hotelDetails?.hotel_config?.required_guest_details.includes(
                    'first_name'
                )
            ) {
                dataObj['first_name'] = firstName;
            }
            if (
                hotelDetails?.hotel_config?.required_guest_details.includes(
                    'mobile'
                )
            ) {
                dataObj['mobile'] = mobile;
                dataObj['mobile_country_code'] = mobile_country_code;
            }
        }
        try {
            const response = await login(dataObj);
            if (response.status === 201) {
                const data = response.data?.data || {};
                localStorage.setItem('hotel_token', data.access_token);
                const responseProfile = await userData('/user/profile');
                if (responseProfile.status === 200) {
                    const userData = responseProfile.data?.data || {};
                    localStorage.setItem('__uid__', userData.user?.id);
                    ReactGA.event({
                        category: 'Login',
                        action: 'User Login Success',
                        hotelId,
                        email,
                        lastName,
                    });
                    setIsEmptyError('');
                    navigate(`/${forwardUrl}`, { replace: true });
                }
            }
        } catch (e) {
            console.log(e);
            window.alert(t['common_error']);
            window.location.reload();
        } finally {
            setLoading(false);
        }
    };
    const handleMobileChange = (value = '') => {
        let number = '';
        if (value) {
            let numberPattern = /\d+/g;
            number = value.match(numberPattern)?.join('') || '';
        }
        setMobile(number);
    };
    return (
        <div className='login'>
            <span className='closeButton' onClick={() => navigate('/')}>
                X
            </span>
            <img
                src={IMAGE_ROOT_URL + hotelDetails?.logo}
                alt={`${hotelDetails?.name} logo`}
            />
            {!loading ? (
                <>
                    <TextInput
                        type='email'
                        name='email'
                        placeholder={t['login_email_placedholder']}
                        isEmpty={lastName.length > 0}
                        value={email}
                        useValidation
                        validator={EMAIL_REGEXP}
                        onChange={(e) => setEmail(e.target.value)}
                        hidden={
                            hotelDetails?.hotel_config &&
                            !hotelDetails?.hotel_config?.required_guest_details.includes(
                                'email'
                            )
                        }
                    />
                    {isEmptyError &&
                        hotelDetails?.hotel_config?.required_guest_details.includes(
                            'email'
                        ) &&
                        (email === undefined || email === '') && (
                            <p className='errorMsg'>{isEmptyError}</p>
                        )}

                    <TextInput
                        type='text'
                        name='lastName'
                        placeholder={t['last_name']}
                        value={lastName}
                        isEmpty={lastName.length > 0}
                        onChange={(e) => setLastName(e.target.value)}
                        hidden={
                            hotelDetails?.hotel_config &&
                            !hotelDetails?.hotel_config?.required_guest_details.includes(
                                'last_name'
                            )
                        }
                    />
                    {isEmptyError &&
                        hotelDetails?.hotel_config?.required_guest_details.includes(
                            'last_name'
                        ) &&
                        (lastName === undefined || lastName === '') && (
                            <p className={'errorMsg'}>{isEmptyError}</p>
                        )}

                    <TextInput
                        type='text'
                        name='firstName'
                        placeholder={'First Name'}
                        value={firstName}
                        isEmpty={firstName.length > 0}
                        onChange={(e) => setFirstName(e.target.value)}
                        hidden={
                            hotelDetails?.hotel_config &&
                            !hotelDetails?.hotel_config?.required_guest_details.includes(
                                'first_name'
                            )
                        }
                    />
                    {isEmptyError &&
                        hotelDetails?.hotel_config?.required_guest_details.includes(
                            'first_name'
                        ) &&
                        (firstName === undefined || firstName === '') && (
                            <p className={styles.errorMsg}>{isEmptyError}</p>
                        )}
                    {hotelDetails?.hotel_config?.required_guest_details.includes(
                        'mobile'
                    ) && (
                        <div className='mobile-input-wrapper'>
                            <select
                                name='mobile_country_code'
                                id='mobile_country_code'
                                onChange={(e) =>
                                    setmobile_country_code(e.target.value)
                                }
                                value={mobile_country_code}
                            >
                                {countryList.map((item) => (
                                    <option value={item.code_value}>
                                        {item.emoji} {item.dial_code}
                                    </option>
                                ))}
                            </select>
                            <TextInput
                                type='tel'
                                name='mobile'
                                placeholder={'Mobile number'}
                                value={mobile}
                                isEmpty={mobile?.length > 0}
                                onChange={(e) =>
                                    handleMobileChange(e.target.value)
                                }
                                hidden={
                                    hotelDetails?.hotel_config &&
                                    !hotelDetails?.hotel_config?.required_guest_details.includes(
                                        'mobile'
                                    )
                                }
                                autoComplete='off'
                            />
                        </div>
                    )}

                    {isEmptyError &&
                        hotelDetails?.hotel_config?.required_guest_details.includes(
                            'mobile'
                        ) &&
                        (mobile === undefined || mobile === '') && (
                            <p className={styles.errorMsg}>{isEmptyError}</p>
                        )}

                    <TextInput
                        type='text'
                        name='fullName'
                        placeholder={t['login_name_placedholder']}
                        value={fullName}
                        isEmpty={lastName.length > 0}
                        onChange={(e) => setFullName(e.target.value)}
                        hidden={
                            hotelDetails?.hotel_config &&
                            !hotelDetails?.hotel_config?.required_guest_details.includes(
                                'name'
                            )
                        }
                    />
                    {isEmptyError &&
                        hotelDetails?.hotel_config?.required_guest_details.includes(
                            'name'
                        ) &&
                        (fullName === undefined || fullName === '') && (
                            <p className={styles.errorMsg}>{isEmptyError}</p>
                        )}

                    <div className='disclaimerWrapper'>
                        {/* {hotelDetails?.hotel_config?.required_guest_details.includes(
              "last_name"
            ) ||
            hotelDetails?.hotel_config?.required_guest_details.includes(
              "email"
            ) ? ( */}
                        <p>
                            We do not store guest data in any form. Your name
                            and/or email on your reservation is required only to
                            identify your unique requests during your stay
                        </p>
                        {/* ) : (
              <p>
                We do not save your personal details in any form. Your
                credentials are required only to identify your unique requests
                during your stay.
              </p>
            )} */}
                    </div>
                    <div className='buttonWrapper'>
                        <Button onClick={() => handleSubmit()}>
                            {t['common_proceed_btn']}
                        </Button>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </div>
    );
};

export default Login;
